import { useState, useEffect, useRef } from 'react';
import { apiB2B, apiB2C } from '../api/axios-client';
import { isLoggedIn } from '../utils/user';
import { ERR_REDIRECT } from '../constants/response-error-messages';
const apiErrorCodesB2B = [401, 431];
const apiErrorCodesB2C = [401, 431, 404];
const logonMiddleware = (error, errorCodes, errorCodeCallback) => {
    const { response } = error;
    const hasError = errorCodes.find((i) => (response === null || response === void 0 ? void 0 : response.status) === i);
    if (response && hasError) {
        errorCodeCallback();
    }
    return Promise.reject(error);
};
export const useInterceptors = () => {
    const [redirectError, setRedirectError] = useState(null);
    const b2bInterceptor = useRef(null);
    const b2cInterceptor = useRef(null);
    useEffect(() => {
        if (!isLoggedIn()) {
            redirectToSignIn();
        }
    }, []);
    const redirectToSignIn = () => {
        if (typeof window !== 'undefined') {
            window.location.replace(`/auth/view/signin?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`);
        }
        setRedirectError(ERR_REDIRECT);
    };
    b2bInterceptor.current =
        b2bInterceptor.current !== null
            ? b2bInterceptor.current
            : apiB2B.interceptors.response.use(undefined, (error) => logonMiddleware(error, apiErrorCodesB2B, redirectToSignIn));
    b2cInterceptor.current =
        b2cInterceptor.current !== null
            ? b2cInterceptor.current
            : apiB2C.interceptors.response.use(undefined, (error) => logonMiddleware(error, apiErrorCodesB2C, redirectToSignIn));
    useEffect(() => {
        return () => {
            if (b2bInterceptor.current !== null) {
                apiB2B.interceptors.response.eject(b2bInterceptor.current);
            }
            if (b2cInterceptor.current !== null) {
                apiB2C.interceptors.response.eject(b2cInterceptor.current);
            }
        };
    }, []);
    return {
        redirectError,
    };
};
